import { lazy } from "react";

/**
 * Route-level code splitting for every screen behind the shell.
 *
 * Extracted from `App.tsx` so that file stays about application state rather
 * than import boilerplate. Mounting these eagerly — sonner in particular —
 * pushed the entry chunk past the 200 KB budget the build enforces.
 */

export const Toaster = lazy(async () => {
  const module = await import("../components/ui/sonner.js");
  return { default: module.Toaster };
});

export const AppShell = lazy(async () => {
  const module = await import("../components/AppShell.js");
  return { default: module.AppShell };
});

export const Billing = lazy(async () => {
  const module = await import("../screens/Billing.js");
  return { default: module.Billing };
});

export const Dashboard = lazy(async () => {
  const module = await import("../screens/Dashboard.js");
  return { default: module.Dashboard };
});

export const Onboarding = lazy(async () => {
  const module = await import("../screens/Onboarding.js");
  return { default: module.Onboarding };
});

export const Provisioning = lazy(async () => {
  const module = await import("../screens/Provisioning.js");
  return { default: module.Provisioning };
});

export const Workspace = lazy(async () => {
  const module = await import("../screens/Workspace.js");
  return { default: module.Workspace };
});

export const Settings = lazy(async () => {
  const module = await import("../screens/Settings.js");
  return { default: module.Settings };
});

export const SignIn = lazy(async () => {
  const module = await import("../screens/SignIn.js");
  return { default: module.SignIn };
});

export const Team = lazy(async () => {
  const module = await import("../screens/Team.js");
  return { default: module.Team };
});
